<template>
  <SideDishBody />
</template>

<script>
import SideDishBody from '../molecules/SideDishBody.vue'


export default {
  name: 'SideDishView',
  components: {
    SideDishBody,
  }
}
</script>
